export class MessageHandler {
  public static INTERNAL_ERROR = 'We are unable to serve your request at this time.';
  public static CONCURRENT_SESSION_WARNING = 'User is already logged in some other system, do you want to login here?';
  public static SESSION_EXPIRED = 'Session Expired please login again.';
  public static NO_SCREEN_ACCESS = 'You do not have the permission to view any screen. Please contact the admin.';
  public static FILE_MISSING_IN_ASSIGN = 'You should assign atleast one file in each of the subgroup.';
  public static FILE_DOES_NOT_EXIST = 'This file is not available for download. Please contact the admin.';
  public static INTERVENTION_ALREADY_EXISTS = 'This Intervention already exists!';
  public static DATA_SAVE_SUCCESS = 'Data Saved Successfully';
  public static AGGREGATE_PROCESSING_ERROR = 'Error in Aggregate Processing';
}
